import { Box, Flex, Heading, Text, Tooltip } from '@chakra-ui/react';

import {
	ResponsiveContainer,
	LabelList,
	Bar,
	BarChart,
	CartesianGrid,
	XAxis,
	YAxis,
} from 'recharts';

const colores = ['#2B6CB0', '#ED8936', '#CBD5E0']; // nuevas, contacto_30_90, contacto_90_plus

const NoticiasPorResponsableChart = ({ data }) => {
	const alto = Math.max(data.length * 45, 300);

	return (
		<Flex justify='center' gap={8} align='center' wrap='wrap'>
			<Heading size='md' mb={2}>
				Noticias activas por responsable (último contacto)
			</Heading>
			<Box overflowX='auto'>
				<Box minW='700px'>
					<Flex gap={4} mb={4} wrap='wrap'>
						<Flex align='center'>
							<Box
								w={3}
								h={3}
								bg={colores[0]}
								borderRadius='full'
								mr={2}
							/>
							<Text fontSize='sm'>Nueva</Text>
						</Flex>
						<Flex align='center'>
							<Box
								w={3}
								h={3}
								bg={colores[1]}
								borderRadius='full'
								mr={2}
							/>
							<Text fontSize='sm'>30–90 días</Text>
						</Flex>
						<Flex align='center'>
							<Box
								w={3}
								h={3}
								bg={colores[2]}
								borderRadius='full'
								mr={2}
							/>
							<Text fontSize='sm'>&gt; 90 días</Text>
						</Flex>
					</Flex>
					<ResponsiveContainer width='100%' height={alto}>
						<BarChart layout='vertical' data={data}>
							<CartesianGrid strokeDasharray='3 3' />
							<XAxis type='number' />
							<YAxis
								type='category'
								dataKey='nombre'
								width={160}
							/>
							<Tooltip />
							<Bar dataKey='nuevas' stackId='a' fill={colores[0]}>
								<LabelList
									dataKey='nuevas'
									position='insideRight'
								/>
							</Bar>
							<Bar
								dataKey='contacto_30_90'
								stackId='a'
								fill={colores[1]}
							>
								<LabelList
									dataKey='contacto_30_90'
									position='insideRight'
								/>
							</Bar>
							<Bar
								dataKey='contacto_90_plus'
								stackId='a'
								fill={colores[2]}
							>
								<LabelList
									dataKey='contacto_90_plus'
									position='insideRight'
								/>
							</Bar>
						</BarChart>
					</ResponsiveContainer>
				</Box>
			</Box>
		</Flex>
	);
};

export default NoticiasPorResponsableChart;
